import { Component, Input } from '@angular/core';
import { BibItem } from '../../providers/item/item';
import { Subject } from 'rxjs/Subject';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoBibCoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-bib-cover',
  templateUrl: 'co-bib-cover.html'
})
export class CoBibCoverComponent {
  @Input('bibDetails') bibDetails: BibItem;
  public updateObserver: Subject<Array<number>>;
  coverImage: string;
  errorImage: string;
  fullDescription: string;

  constructor(private state : AppState) {
    setInterval(()=>this.update(), 500);//#TODO: fix this silly hack
  }
  public update(){
    if(this.updateObserver)this.updateObserver.next();
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.updateObserver =new Subject();
  }
  ngOnChanges(){
    let server = Math.floor(Math.random() * 9);
    this.errorImage = `http://covers${server}.communico.co/gen/cover?title=`+encodeURIComponent(this.bibDetails.title);
    if (this.bibDetails.imageLinks && this.bibDetails.imageLinks.length > 0){
      this.coverImage = this.bibDetails.imageLinks[0].url;
    } else if (this.bibDetails.upcs && this.bibDetails.upcs.length>0 && this.bibDetails.upcs[0]) {
      this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.upcs[0]}`;
    } else if(this.bibDetails.isbns && this.bibDetails.isbns.length>0){
      this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.isbns[0]}`;
    }else{
      this.coverImage = this.errorImage;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-bib-cover/co-bib-cover.ts